// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateQuestionablePartSearchCriteria = partNumber => ({
    partNumber,
    type: actions.UPDATE_QUESTIONABLE_PART_SEARCH_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/questionable-part-search/action-creators/criteria.js